enum TicketStatus {
    UNPAID = 'unpaid',
    PAID = 'paid',
    VALID = 'valid',
    EXPIRED = 'expired',
    REVOKED = 'revoked'
}

export default TicketStatus